import React, { forwardRef, useState } from 'react';
import { Calendar, Button, TimePicker } from 'antd';
import dayjs from 'dayjs';
import { current } from '@reduxjs/toolkit';

const BaseCalender2 = (props) => {
  // const { token } = theme.useToken();
  const { onSelectedDate, onOpenChange } = props;

  const [selected, setSelected] = useState(dayjs());
  const [hourMin, setHourMin] = useState(dayjs().format('HH:mm:00'));

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '30rem',
      height: '35.2.rem',
      // border: `1px solid ${token.colorBorderSecondary}`,
      boxShadow: '0px 4px 16px rgba(165, 163, 174, 0.45)',
      borderRadius: 6,
    },
    row: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    time_box: {
      display: 'flex',
      width: 120,
      height: 30,
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #7367F0',
      borderRadius: 6,
      //format
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
    },
    // circle: {},
    button: {
      display: 'flex',
      width: '2.8rem',
      height: '2.8rem',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FFF',
      background: '#7367F0',
      borderRadius: 30,
    },
  };

  const headerRender = ({ value, type, onChange, onTypeChange }) => {
    const current = value.clone();
    const prevMonth = dayjs(current).subtract(1, 'month');
    const nextMonth = dayjs(current).add(1, 'month');
    return (
      <div
        style={{
          ...styles.row,
          height: '5.8rem',
        }}
      >
        <div style={{ width: '50%', paddingLeft: '1.6rem' }}>
          {dayjs(current).format('YYYY-MM')}
        </div>
        <div style={{ ...styles.row, width: '7.2rem', marginRight: '1.6rem' }}>
          <Button
            type="circle"
            style={{ ...styles.button }}
            onClick={(e) => {
              onChange(prevMonth);
            }}
          >{`<`}</Button>
          <Button
            type="circle"
            style={{
              ...styles.button,
            }}
            onClick={(e) => {
              onChange(nextMonth);
            }}
          >{`>`}</Button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ ...styles.container }}>
      <Calendar
        // value={dayjs()}
        fullscreen={false}
        headerRender={headerRender}
        onSelect={(e) => {
          // 날짜 선택
          setSelected(e);
        }}
      />
      <div
        style={{
          ...styles.row,
          width: '100%',
          height: '5.4rem',
          borderTop: '1px solid #DBDADE',
          background: '#FFF',
        }}
      >
        <div style={{ ...styles.time_box, marginLeft: '1.2rem' }}>
          {/* {dayjs().format('A hh:mm')} */}
          <TimePicker
            // format={'A:hh:mm'}
            style={{ width: '100%' }}
            size="small"
            format={'HH:mm'}
            // defaultValue={dayjs()}
            value={dayjs(`${dayjs().format('YYYY-MM-DD')} ${hourMin}`)}
            onChange={(e) => {
              setHourMin(dayjs(e).format('HH:mm:00'));
            }}
            showNow={false}
            renderExtraFooter={() => (
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  setHourMin(dayjs().format('HH:mm:00'));
                }}
              >
                Now
              </Button>
            )}
          />
        </div>
        <Button
          style={{
            ...styles.button,
            color: '#FFF',
            background: '#A8AAAE',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: 4,
          }}
          onClick={(e) => {
            onOpenChange && onOpenChange(false);
          }}
        >{`취소`}</Button>
        <Button
          style={{
            ...styles.button,
            marginRight: '1.2rem',
            width: '7.2rem',
            height: '3.rem',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: 4,
          }}
          onClick={(e) => {
            // alert(dayjs(selected).format('YYYY-MM-DD HH:mm'));
            const selectTime = dayjs(selected).format(`YYYY-MM-DD ${hourMin}`);
            onSelectedDate && onSelectedDate(dayjs(selectTime));
            onOpenChange && onOpenChange(false);
          }}
        >{`적용`}</Button>
      </div>
    </div>
  );
};

export default forwardRef(BaseCalender2);
{
  /* 
	  const onPanelChange = (value, mode) => {
    console.log(value.format('YYYY-MM-DD'), mode);
  };
	<Calendar fullscreen={false} onPanelChange={onPanelChange} {...props} />
	
	*/
}
